import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Stop scrolling Pinterest for recipes and have a delicious dinner ready with ease.', 'Stop stressing about cooking each day—just pull a package from your freezer and activate it.', 'Stop fighting your kids at dinner time and actually get to sit down and enjoy time with them.', "Stop meal planning every week; it's all provided for you in this Protocol.", 'Stop spending money on takeout and give your family real home-cooked meals!'];
export const SolutionBenefits = () => {
  return <section className="bg-gray-50 px-4 py-8 md:py-16 lg:px-8" data-id="element-228">
      <div className="mx-auto max-w-4xl" data-id="element-229">
        <div className="rounded-3xl bg-white p-8 shadow-xl md:p-12" data-id="element-230">
          <ul className="space-y-6" data-id="element-231">
            {benefits.map((benefit, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start space-x-4" data-id="element-232">
                <CheckCircle2 className="mt-1 h-6 w-6 flex-shrink-0 text-terracotta" data-id="element-233" />
                <span className="text-lg font-medium text-text-dark md:text-xl" data-id="element-234">
                  {benefit}
                </span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} className="mt-10 border-t border-gray-100 pt-8 text-center" data-id="element-235">
            <p className="font-serif text-2xl italic text-terracotta md:text-3xl" data-id="element-236">
              You deserve to enjoy your evenings without the weight of not
              knowing what you're going to feed your family.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};